module.exports = __webpack_public_path__ + "static/media/SheJiao3.66064fd1.png";